// src/components/Sidebar.js
import { Box, Image, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom"; // Importando useNavigate
import { jwtDecode } from "jwt-decode"; // Updated import
import { useEffect, useState } from "react";

const Sidebar = ({ onLogout }) => { 
    const navigate = useNavigate();
    const [userLevel, setUserLevel] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            const decoded = jwtDecode(token);
            setUserLevel(decoded.role);
        }
    }, []);

    return (
        <Box
            bg="teal.500"
            color="white"
            position="fixed"
            h="100vh"
            w="250px"
            p={4}
            display="flex"
            flexDirection="column"
            alignItems="center"
        >
            <Image src="/assets/fiscalizer_white.png" alt="Fiscalizer Logo" onClick={() => navigate('/dashboard')} style={{ width: '100%', marginBottom: '40px', cursor: 'pointer' }} />
            
            {/* Menu para todos os usuários (nível 1+) */}
            <Button bg='white' color='teal.500' mb='10px' boxShadow="md" p={4} width={'90%'} onClick={() => navigate('/dashboard')}>Home</Button>
            <Button bg='white' color='teal.500' mb='10px' boxShadow="md" p={4} width={'90%'} onClick={() => navigate('/passages')}>Passagens</Button>
            
            {/* Menu para usuários nível 2+ */}
            {userLevel >= 2 && (
                <>
                    <Button bg='white' color='teal.500' mb='10px' boxShadow="md" p={4} width={'90%'} onClick={() => navigate('/infractions')}>Infrações</Button>
                    <Button bg='white' color='teal.500' mb='10px' boxShadow="md" p={4} width={'90%'} onClick={() => navigate('/batches')}>Lotes</Button>
                </>
            )}
            
            {/* Menu para usuários nível 3+ (Validação) */}
            {userLevel >= 3 && (
                <>
                    <Button bg='white' color='teal.500' mb='10px' boxShadow="md" p={4} width={'90%'} onClick={() => navigate('/faces')}>Faces</Button>
                </>
            )}
            
            {/* Menu para usuários nível 4+ (Supervisão) */}
            {userLevel >= 4 && (
                <>
                    <Button bg='white' color='teal.500' mb='10px' boxShadow="md" p={4} width={'90%'} onClick={() => navigate('/machines')}>Máquinas</Button>
                    <Button bg='white' color='teal.500' mb='10px' boxShadow="md" p={4} width={'90%'} onClick={() => navigate('/cameras')}>Câmeras</Button>
                    <Button bg='white' color='teal.500' mb='10px' boxShadow="md" p={4} width={'90%'} onClick={() => navigate('/algorithms')}>Algoritmos</Button>
                </>
            )}
            
            {/* Menu para usuários nível 5+ (Administrador) */}
            {userLevel >= 5 && (
                <>
                <Button bg='white' color='teal.500' mb='10px' boxShadow="md" p={4} width={'90%'} onClick={() => navigate('/users')}>Usuários</Button>
                </>
            )}

            {/* Configurações para nível 3+ */}
            {userLevel >= 3 && (
                <Button bg='white' color='teal.500' mb='10px' boxShadow="md" p={4} width={'90%'} onClick={() => navigate('/settings')}>Configurações</Button>
            )}
            
            <Button color='red' mt='auto' boxShadow="md" p={4} width={'90%'} onClick={onLogout}>Logout</Button>
        </Box>
    );
};

export default Sidebar;
